import * as React from 'react';

function Asserbishvil(props) {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="0.5"
                y="0.5"
                width="25"
                height="25"
                rx="12.5"
                stroke="#B0C9EB"
            />
            <g clipPath="url(#clip0_1124_779)">
                <path
                    d="M10.7002 14.2727L11.2417 12.8899H11.4962L12.0493 14.2727H11.7949L11.6342 13.8955H11.2254L11.3068 13.6729H11.572L11.363 13.1535L10.9426 14.2723H10.6998L10.7002 14.2727Z"
                    fill="#00BFDF"
                />
                <path
                    d="M12.2236 14.2148V13.9827C12.3516 14.0342 12.496 14.0601 12.6571 14.0601C12.8529 14.0601 12.9506 13.9892 12.9506 13.8475C12.9506 13.7442 12.8904 13.6928 12.7704 13.6928H12.5526C12.2914 13.6928 12.161 13.564 12.161 13.306C12.161 13.0225 12.3469 12.8804 12.7185 12.8804C12.8613 12.8804 12.9965 12.9028 13.1245 12.9482V13.1803C12.9965 13.1288 12.8613 13.1029 12.7185 13.1029C12.5044 13.1029 12.3975 13.1708 12.3975 13.306C12.3975 13.4093 12.4493 13.4607 12.5526 13.4607H12.7704C13.0484 13.4607 13.1871 13.5895 13.1871 13.8475C13.1871 14.1374 13.0105 14.2826 12.6571 14.2826C12.496 14.2826 12.3512 14.2602 12.2236 14.2148Z"
                    fill="#00BFDF"
                />
                <path
                    d="M13.3068 14.2148V13.9827C13.4348 14.0342 13.5792 14.0601 13.7403 14.0601C13.9361 14.0601 14.0338 13.9892 14.0338 13.8475C14.0338 13.7442 13.9736 13.6928 13.8535 13.6928H13.6358C13.3746 13.6928 13.2442 13.564 13.2442 13.306C13.2442 13.0225 13.43 12.8804 13.8017 12.8804C13.9445 12.8804 14.0797 12.9028 14.2077 12.9482V13.1803C14.0797 13.1288 13.9445 13.1029 13.8017 13.1029C13.5875 13.1029 13.4807 13.1708 13.4807 13.306C13.4807 13.4093 13.5325 13.4607 13.6358 13.4607H13.8535C14.1315 13.4607 14.2703 13.5895 14.2703 13.8475C14.2703 14.1374 14.0936 14.2826 13.7403 14.2826C13.5792 14.2826 13.4344 14.2602 13.3068 14.2148Z"
                    fill="#00BFDF"
                />
                <path
                    d="M15.296 12.8901V13.1105H14.6926V13.4583H15.2657V13.6874H14.6902V14.0499H15.3088V14.2725H14.4585V12.8896H15.2964L15.296 12.8901Z"
                    fill="#00BFDF"
                />
                <path
                    d="M15.5628 14.2705V12.8899H16.1427C16.4031 12.8899 16.5335 13.0135 16.5335 13.2602C16.5335 13.427 16.4322 13.5653 16.2292 13.6751L16.6336 14.2727H16.3266L15.9385 13.6703V13.5532C16.1706 13.5113 16.2867 13.4162 16.2867 13.268C16.2867 13.166 16.2336 13.115 16.1279 13.115H15.8041V14.2705H15.5632H15.5628Z"
                    fill="#00BFDF"
                />
                <path
                    d="M17.1022 14.2727V12.8899H17.7C17.9429 12.8899 18.0642 12.9971 18.0642 13.2118C18.0642 13.3691 17.9852 13.4815 17.8269 13.5493C17.996 13.5835 18.0801 13.688 18.0801 13.8635C18.0801 14.1362 17.9473 14.2727 17.6813 14.2727H17.1022ZM17.6717 14.0502C17.7766 14.0502 17.8289 13.9923 17.8289 13.876C17.8289 13.7321 17.7507 13.6604 17.5944 13.6604H17.523V13.4953C17.7192 13.4599 17.8173 13.3709 17.8173 13.2282C17.8173 13.1509 17.7734 13.1124 17.6853 13.1124H17.3391V14.0502H17.6721H17.6717Z"
                    fill="#00BFDF"
                />
                <path
                    d="M18.5076 12.8899V14.2727H18.2711V12.8899H18.5076Z"
                    fill="#00BFDF"
                />
                <path
                    d="M18.7932 14.2148V13.9827C18.9212 14.0342 19.0656 14.0601 19.2267 14.0601C19.4225 14.0601 19.5202 13.9892 19.5202 13.8475C19.5202 13.7442 19.46 13.6928 19.3399 13.6928H19.1222C18.861 13.6928 18.7306 13.564 18.7306 13.306C18.7306 13.0225 18.9164 12.8804 19.2881 12.8804C19.4309 12.8804 19.5661 12.9028 19.6941 12.9482V13.1803C19.5661 13.1288 19.4309 13.1029 19.2881 13.1029C19.0739 13.1029 18.9671 13.1708 18.9671 13.306C18.9671 13.4093 19.0189 13.4607 19.1222 13.4607H19.3399C19.6179 13.4607 19.7567 13.5895 19.7567 13.8475C19.7567 14.1374 19.58 14.2826 19.2267 14.2826C19.0656 14.2826 18.9208 14.2602 18.7932 14.2148Z"
                    fill="#00BFDF"
                />
                <path
                    d="M19.9441 14.2727V12.8899H20.1806V13.4603H20.8099V12.8899H21.0464V14.2727H20.8099V13.6828H20.1806V14.2727H19.9441Z"
                    fill="#00BFDF"
                />
                <path
                    d="M22.5296 12.8899L21.9701 14.2727H21.7156L21.18 12.8899H21.4612L21.8564 13.9486L22.2508 12.8899H22.5292H22.5296Z"
                    fill="#00BFDF"
                />
                <path
                    d="M22.8997 12.8899V14.2727H22.6632V12.8899H22.8997Z"
                    fill="#00BFDF"
                />
                <path
                    d="M23.4038 12.8899V14.0502H24V14.2727H23.1673V12.8899H23.4038Z"
                    fill="#00BFDF"
                />
                <path
                    d="M11.5381 14.6076V14.828H10.9347V15.1759H11.5077V15.4049H10.9323V15.99H10.7002V14.6072H11.5381V14.6076Z"
                    fill="#00BFDF"
                />
                <path
                    d="M11.7478 15.3007C11.7478 14.8323 11.9616 14.5977 12.3887 14.5977C12.8158 14.5977 13.0196 14.8319 13.0196 15.3007C13.0196 15.7696 12.8095 15.9999 12.3887 15.9999C11.968 15.9999 11.767 15.767 11.7478 15.3007ZM12.3887 15.7774C12.6455 15.7774 12.7744 15.6166 12.7744 15.2947C12.7744 14.9727 12.6459 14.8198 12.3887 14.8198C12.1315 14.8198 11.9935 14.9779 11.9935 15.2947C11.9935 15.6114 12.1251 15.7774 12.3887 15.7774Z"
                    fill="#00BFDF"
                />
                <path
                    d="M13.2426 15.4469V14.6077H13.4791V15.4469C13.4791 15.6672 13.5832 15.7774 13.7913 15.7774C13.9995 15.7774 14.1036 15.6672 14.1036 15.4469V14.6077H14.3401V15.4469C14.3401 15.8155 14.157 16 13.7913 16C13.4256 16 13.2426 15.8155 13.2426 15.4469Z"
                    fill="#00BFDF"
                />
                <path
                    d="M14.6081 15.9905V14.6077H14.8446L15.5541 15.5959V14.6077H15.7818V15.9905H15.5453L14.8358 14.981V15.9905H14.6081Z"
                    fill="#00BFDF"
                />
                <path
                    d="M16.049 15.9905V14.6077H16.6021C17.0005 14.6077 17.1999 14.8255 17.1999 15.261C17.1999 15.7472 17.0005 15.99 16.6021 15.99H16.049V15.9905ZM16.5666 15.7679C16.8314 15.7679 16.9638 15.599 16.9638 15.2615C16.9638 14.9741 16.8314 14.8302 16.5666 14.8302H16.2855V15.7679H16.5666Z"
                    fill="#00BFDF"
                />
                <path
                    d="M17.312 15.9905L17.8536 14.6077H18.108L18.6612 15.9905H18.4067L18.246 15.6132H17.8372L17.9186 15.3907H18.1838L17.9748 14.8713L17.5545 15.99H17.3116L17.312 15.9905Z"
                    fill="#00BFDF"
                />
                <path
                    d="M19.5393 14.6077V14.8302H19.1732V15.9905H18.9367V14.8302H18.571V14.6077H19.5393Z"
                    fill="#00BFDF"
                />
                <path
                    d="M19.9098 14.6077V15.9905H19.6733V14.6077H19.9098Z"
                    fill="#00BFDF"
                />
                <path
                    d="M20.1328 15.3007C20.1328 14.8323 20.3461 14.5977 20.7737 14.5977C21.2012 14.5977 21.4046 14.8319 21.4046 15.3007C21.4046 15.7696 21.1944 15.9999 20.7737 15.9999C20.3529 15.9999 20.1519 15.767 20.1328 15.3007ZM20.7737 15.7774C21.0305 15.7774 21.1593 15.6166 21.1593 15.2947C21.1593 14.9727 21.0309 14.8198 20.7737 14.8198C20.5164 14.8198 20.3784 14.9779 20.3784 15.2947C20.3784 15.6114 20.51 15.7774 20.7737 15.7774Z"
                    fill="#00BFDF"
                />
                <path
                    d="M21.6275 15.9905V14.6077H21.864L22.5735 15.5959V14.6077H22.8012V15.9905H22.5647L21.8552 14.981V15.9905H21.6275Z"
                    fill="#00BFDF"
                />
                <path
                    d="M4.72085 9.96826H3V11.8329H4.72085V9.96826Z"
                    fill="#58595B"
                />
                <path
                    d="M4.72085 12.0403H3V13.9049H4.72085V12.0403Z"
                    fill="#58595B"
                />
                <path
                    d="M4.72085 14.1121H3V15.9767H4.72085V14.1121Z"
                    fill="#58595B"
                />
                <path
                    d="M6.66464 9.96826H4.94379V11.8329H6.66464V9.96826Z"
                    fill="#58595B"
                />
                <path
                    d="M6.66464 12.0403H4.94379V13.9049H6.66464V12.0403Z"
                    fill="#58595B"
                />
                <path
                    d="M6.66464 14.1121H4.94379V15.9767H6.66464V14.1121Z"
                    fill="#58595B"
                />
                <path
                    d="M8.60882 9.96826H6.88797V11.8329H8.60882V9.96826Z"
                    fill="#58595B"
                />
                <path
                    d="M8.60882 12.0403H6.88797V13.9049H8.60882V12.0403Z"
                    fill="#58595B"
                />
                <path
                    d="M10.4892 8H8.76836V9.86464H10.4892V8Z"
                    fill="#00BFDF"
                />
                <path
                    d="M8.60882 14.1121H6.88797V15.9767H8.60882V14.1121Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9359 11.1204H11.6621V11.4744C11.6621 11.5729 11.6545 11.6554 11.637 11.7155C11.6194 11.7786 11.5887 11.8417 11.546 11.9048L11.4802 12.0007C11.4144 12.0992 11.3789 12.2038 11.3789 12.3131V12.5409H11.1437V12.349C11.1437 12.2336 11.1536 12.1489 11.1764 12.0884C11.1967 12.0309 11.227 11.973 11.2673 11.9186L11.3407 11.817C11.3785 11.7678 11.4013 11.7211 11.4117 11.6801C11.4216 11.6416 11.4268 11.5897 11.4268 11.5266V11.3348H10.7006V10.5781H10.9359V11.1209V11.1204Z"
                    fill="#58595B"
                />
                <path
                    d="M12.0948 11.1204H11.8543V11.8554H12.0948V11.1204Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2577 12.3268H13.4651V12.5407H12.2101V12.3268H13.02V11.8415C13.02 11.7097 13.0073 11.6112 12.9794 11.5425C12.9514 11.4768 12.9036 11.4245 12.8326 11.3861C12.7616 11.345 12.6503 11.3256 12.4984 11.3256C12.4453 11.3256 12.3616 11.3312 12.2503 11.3446L12.23 11.1333C12.3413 11.1143 12.4601 11.103 12.5841 11.103C12.8218 11.103 12.9917 11.1579 13.0978 11.2703C13.2043 11.38 13.2573 11.5473 13.2573 11.772V12.326L13.2577 12.3268Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.7491 11.1203L13.7542 11.3506C13.7594 11.5866 13.767 11.7508 13.7822 11.8415C13.8683 11.8415 13.9465 11.8169 14.0175 11.7702C14.0884 11.7236 14.1239 11.6332 14.1239 11.5014L14.1491 11.1203H14.3867L14.3564 11.5671C14.3513 11.644 14.3437 11.7015 14.3337 11.74C14.3209 11.7784 14.301 11.8195 14.2655 11.8636C14.2328 11.9076 14.1794 11.9457 14.1088 11.9789C14.0354 12.0118 13.9393 12.0338 13.8176 12.0446C13.838 12.1406 13.8858 12.2175 13.962 12.275C14.0354 12.3324 14.1291 12.3627 14.238 12.3627C14.3393 12.3627 14.4254 12.3355 14.4988 12.2832C14.5722 12.2309 14.6252 12.1652 14.6607 12.0831C14.6934 12.001 14.7166 11.883 14.7289 11.7292L14.782 11.1203H15.0197L14.9742 11.6466C14.9566 11.8441 14.9259 12.0088 14.8805 12.1375C14.8374 12.2693 14.7588 12.3761 14.6504 12.4582C14.5391 12.5377 14.3971 12.5787 14.2252 12.5787C14.0709 12.5787 13.9417 12.5377 13.838 12.4582C13.7315 12.3761 13.6557 12.2607 13.6027 12.1125C13.552 11.9617 13.5269 11.7616 13.5269 11.5118L13.5094 11.1199H13.7498L13.7491 11.1203Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.1136 12.3268H16.321V12.5407H15.0659V12.3268H15.8759V11.8415C15.8759 11.7097 15.8631 11.6112 15.8352 11.5425C15.8073 11.4768 15.7594 11.4245 15.6885 11.3861C15.6175 11.345 15.5062 11.3256 15.3543 11.3256C15.3012 11.3256 15.2175 11.3312 15.1062 11.3446L15.0859 11.1333C15.1971 11.1143 15.316 11.103 15.44 11.103C15.6777 11.103 15.8476 11.1579 15.9537 11.2703C16.0601 11.38 16.1132 11.5473 16.1132 11.772V12.326L16.1136 12.3268Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.8578 11.1343C16.9842 11.1152 17.1006 11.104 17.2071 11.104C17.4727 11.104 17.6578 11.1589 17.7615 11.2712C17.8651 11.381 17.9182 11.5482 17.9182 11.7729V12.5408H17.6829V11.8416C17.6829 11.7129 17.6701 11.6139 17.645 11.5482C17.6199 11.4825 17.5692 11.4277 17.4982 11.3892C17.4249 11.3482 17.3236 11.3261 17.192 11.3261C17.1058 11.3261 16.9997 11.3343 16.8757 11.3533L16.8582 11.1338L16.8578 11.1343Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.3242 11.1203L18.3294 11.3506C18.3345 11.5866 18.3421 11.7508 18.3573 11.8415C18.4434 11.8415 18.5216 11.8169 18.5926 11.7702C18.6636 11.7236 18.6991 11.6332 18.6991 11.5014L18.7242 11.1203H18.9619L18.9316 11.5671C18.9264 11.644 18.9188 11.7015 18.9088 11.74C18.8961 11.7784 18.8761 11.8195 18.8406 11.8636C18.8079 11.9076 18.7545 11.9457 18.6839 11.9789C18.6105 12.0118 18.5144 12.0338 18.3928 12.0446C18.4131 12.1406 18.461 12.2175 18.5371 12.275C18.6105 12.3324 18.7042 12.3627 18.8131 12.3627C18.9144 12.3627 19.0005 12.3355 19.0739 12.2832C19.1473 12.2309 19.2004 12.1652 19.2358 12.0831C19.2685 12.001 19.2917 11.883 19.304 11.7292L19.3571 11.1203H19.5948L19.5493 11.6466C19.5318 11.8441 19.5011 12.0088 19.4556 12.1375C19.4125 12.2693 19.334 12.3761 19.2255 12.4582C19.1142 12.5377 18.9722 12.5787 18.8003 12.5787C18.646 12.5787 18.5168 12.5377 18.4131 12.4582C18.3066 12.3761 18.2309 12.2607 18.1778 12.1125C18.1272 11.9617 18.102 11.7616 18.102 11.5118L18.0845 11.1199H18.325L18.3242 11.1203Z"
                    fill="#58595B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9701 12.3679L19.7447 11.1204H19.9928L20.185 12.2884C20.3266 12.2279 20.4127 12.1432 20.4482 12.0309C20.4837 11.9185 20.5013 11.7785 20.5013 11.6087L20.514 11.1204H20.7521L20.7421 11.4959C20.7346 11.6769 20.727 11.8057 20.7194 11.877C20.7118 11.9509 20.6891 12.0304 20.656 12.1181C20.6205 12.2059 20.5699 12.2828 20.5017 12.3485C20.4335 12.4116 20.3346 12.4721 20.203 12.5265C20.0737 12.5788 19.8867 12.6281 19.6438 12.6717L19.6111 12.4496C19.7603 12.425 19.8795 12.3973 19.9705 12.3675L19.9701 12.3679Z"
                    fill="#58595B"
                />
            </g>
            <defs>
                <clipPath id="clip0_1124_779">
                    <rect
                        width="21"
                        height="8"
                        fill="white"
                        transform="translate(3 8)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default Asserbishvil;
